import {
  exists,
  InspectionListCollection,
  InspectionListCollectionFromJSON
} from '@/api'

export interface InspectionList {
  total: number
  limit: number
  collections: InspectionListCollection[]
}

export const defaultInspectionList = (): InspectionList => ({
  total: 0,
  limit: 0,
  collections: []
})

export function InspectionListFromJSON(json: any): InspectionList {
  return {
    total: exists(json, 'total') ? json.total : 0,
    limit: exists(json, 'limit') ? json.limit : 0,
    collections: exists(json, 'collections')
      ? json.collections.map(InspectionListCollectionFromJSON)
      : []
  }
}
